import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  HANDOVER_STATUS_ACCEPTED,
  HANDOVER_TYPE_HO3_ID,
} from 'src/app/handover-constants';
import { WellEvent } from 'src/app/interfaces/event';
import { WellStatusProduction } from 'src/app/interfaces/well';
import { HandoverService } from 'src/app/services/handover.service';
import { SectionTouched } from '../../shared/section-touched.class';

@Component({
  selector: 'app-handover-detail-status',
  templateUrl: './handover-detail-status.component.html',
  styleUrls: ['./handover-detail-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailStatusComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() wellId: string | undefined;
  @Input() uwi: string | undefined;
  @Input() handoverTypeId: number | undefined;
  @Input() handoverStatusId: number | undefined;
  @Input() readOnlyContent!: boolean;

  isLoading = false;
  hideFooterEvents = true;
  hideFooterWell = true;
  wellEvents: WellEvent[] = [];
  wellStatusProduction: WellStatusProduction[] = [];
  showEvents = true;
  confirmEvent = false;
  disableToggle = false;
  countConfirm = 0;
  showFooterNoDataOrign = false;

  displayedColumns: string[] = [
    'eventType',
    'dateOpsStart',
    'dateOpsEnd',
    'objective',
    'mainCause',
    'fullCicleComplete',
    'confirmEvent',
  ];

  displayedColumnsStatus: string[] = [
    'productionType',
    'extractionSystem',
    'status',
  ];
  constructor(public handoverService: HandoverService) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverId) {
      this.isLoading = true;
      if (this.handoverTypeId == HANDOVER_TYPE_HO3_ID) {
        this.showEvents = false;
        this.loadWellData();
      } else {
        this.loadWellEvents();
      }
      this.showFooterNoDataOrign =
        this.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
  }

  loadWellEvents() {
    this.handoverService
      .getWellEvents(this.handoverId!, this.wellId!, this.handoverStatusId!)
      .subscribe((values: WellEvent[]) => {
        this.wellEvents = values;
        this.hideFooterEvents = this.wellEvents.length > 0;
        if (this.wellEvents.length == 1) {
          // tenemos que confirmar la fila y deshabilitar
          const wellevent = this.wellEvents[0];
          if (!wellevent.confirmEvent) {
            wellevent.confirmEvent = true;
            this.handoverService
              .saveHandoverEvent(wellevent, this.handoverId!, this.wellId!)
              .subscribe(() => {
                this.disableToggle = true;
              });
          } else {
            this.disableToggle = true;
          }
        }
        // recorremos wellEvents para contar los eventos confirmados
        for (let index = 0; index < this.wellEvents.length; index++) {
          const event = this.wellEvents[index];
          if (event.confirmEvent) {
            this.countConfirm++;
          }
        }
        this.isLoading = false;
      });
  }
  loadWellData() {
    this.handoverService
      .getWellStatusProduction(
        this.handoverId!,
        this.uwi!,
        this.handoverStatusId!
      )
      .subscribe((values: WellStatusProduction[]) => {
        this.wellStatusProduction = values;
        this.isLoading = false;
      });
  }
  toggleConfirmEvent(index: number): void {
    if (this.handoverId && this.wellId) {
      this.wellEvents[index].confirmEvent =
        !this.wellEvents[index].confirmEvent;
      this.handoverService
        .saveHandoverEvent(this.wellEvents[index], this.handoverId, this.wellId)
        .subscribe(() => {
          if (this.wellEvents[index].confirmEvent) {
            this.countConfirm++;
          } else {
            this.countConfirm--;
          }
        });
    }
  }
}
